export default __webpack_public_path__ + "static/media/40.0f330b94.png";